import SequencerOperation from "models/audioEditor/sequencerOperation/SequencerOperation";
import ParagraphBoundaryPreference from "models/audioEditor/ParagraphBoundaryPreference";

const ChangeParagraphBoundaryPreferenceOperation = SequencerOperation.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        SequencerOperation.apply(this, [attributes, options]);
    },

    execute : function(sequencerNode, paragraphBoundaryPreference){
        if(!sequencerNode){
            return false;
        }
        const normalizedPreference = ParagraphBoundaryPreference.normalize(paragraphBoundaryPreference);
        const oldParagraphBoundaryPreference = this._getParagraphBoundaryPreferenceForSequencerNode(sequencerNode);
        if(oldParagraphBoundaryPreference === normalizedPreference){
            return false;
        }
        this._setParagraphBoundaryPreferenceForSequencerNode(sequencerNode, normalizedPreference);
        this.getSequencer().getHistoryManagement().addSequencerOperationChangeParagraphBoundaryPreferenceLog(
            sequencerNode.cid,
            oldParagraphBoundaryPreference,
            normalizedPreference,
        );
        this._notifyParagraphStructureChanged();
        return true;
    },

    _getParagraphBoundaryPreferenceForSequencerNode : function(sequencerNode){
        if(sequencerNode && typeof sequencerNode.getParagraphBoundaryPreference === "function"){
            return ParagraphBoundaryPreference.normalize(sequencerNode.getParagraphBoundaryPreference());
        }
        return ParagraphBoundaryPreference.normalize(sequencerNode ? sequencerNode.get("paragraphBoundaryPreference") : null);
    },

    _setParagraphBoundaryPreferenceForSequencerNode : function(sequencerNode, paragraphBoundaryPreference){
        const normalizedPreference = ParagraphBoundaryPreference.normalize(paragraphBoundaryPreference);
        if(!sequencerNode){
            return null;
        }
        if(typeof sequencerNode.setParagraphBoundaryPreference === "function"){
            return sequencerNode.setParagraphBoundaryPreference(normalizedPreference);
        }
        if(normalizedPreference){
            sequencerNode.set("paragraphBoundaryPreference", normalizedPreference);
            return normalizedPreference;
        }
        if(typeof sequencerNode.unset === "function"){
            sequencerNode.unset("paragraphBoundaryPreference");
        }else{
            sequencerNode.set("paragraphBoundaryPreference", null);
        }
        return null;
    },

    _getSequencerNodeFromLog : function(operationLog){
        const sequencerNodeCid = operationLog && operationLog.getSequencerNodeCid ? operationLog.getSequencerNodeCid() : null;
        if(!sequencerNodeCid){
            return null;
        }
        return this.getSequencer().getSequencerNodeByNodeCid(sequencerNodeCid);
    },

    undo : function(operationLog){
        const sequencerNode = this._getSequencerNodeFromLog(operationLog);
        if(!sequencerNode){
            console.warn("ChangeParagraphBoundaryPreferenceOperation: aborting undo because the logged node no longer resolves");
            return false;
        }
        this._setParagraphBoundaryPreferenceForSequencerNode(
            sequencerNode,
            operationLog.getOldParagraphBoundaryPreference ? operationLog.getOldParagraphBoundaryPreference() : null,
        );
        this._notifyParagraphStructureChanged();
        return true;
    },

    redo : function(operationLog){
        const sequencerNode = this._getSequencerNodeFromLog(operationLog);
        if(!sequencerNode){
            console.warn("ChangeParagraphBoundaryPreferenceOperation: aborting redo because the logged node no longer resolves");
            return false;
        }
        this._setParagraphBoundaryPreferenceForSequencerNode(
            sequencerNode,
            operationLog.getNewParagraphBoundaryPreference ? operationLog.getNewParagraphBoundaryPreference() : null,
        );
        this._notifyParagraphStructureChanged();
        return true;
    },
});

export default ChangeParagraphBoundaryPreferenceOperation;
